import { render, staticRenderFns } from "./pre_reset.vue?vue&type=template&id=754f2510&scoped=true&"
import script from "./pre_reset.vue?vue&type=script&lang=js&"
export * from "./pre_reset.vue?vue&type=script&lang=js&"
import style0 from "./pre_reset.vue?vue&type=style&index=0&id=754f2510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f2510",
  null
  
)

export default component.exports